<template>
  <!-- <v-container class="pa-0"> -->
  <v-responsive
    class="container-responsive"
    :aspect-ratio="16 / 9"
    ref="responsiveContainer"
    :width="responsiveContainerWidth"
  >
    <!-- <v-responsive class="container-responsive" :aspect-ratio="16 / 9" ref="responsiveContainer"> -->
    <!-- <v-container ref="container" fill-height fluid class="container-video" :style="containerVideoCss"> -->
    <!-- <v-container
        ref="container"
        fill-height
        fluid
        class="container-video py-0"
        :style="`background: ${
          screenStream && screenStream !== null && this.faceVideoData.layoutType !== 'corner'
            ? this.bgColor
            : 'tranparent'
        }; padding-left: ${containerPaddingLeft}px; padding-right: ${containerPaddingLeft}px`"
      > -->
    <v-container
      ref="container"
      fill-height
      fluid
      class="container-video pa-0"
      :style="`background: ${
        screenStream && screenStream !== null ? this.bgColor : 'tranparent'
      }; padding-left: ${pixelToVw(containerPaddingLeft)}vw !important; padding-right: ${pixelToVw(
        containerPaddingLeft
      )}vw !important; padding-top: ${pixelToVw(containerPaddingTop)}vw !important; padding-bottom: ${pixelToVw(
        containerPaddingTop
      )}vw !important;`"
    >
      <v-row :class="`${containerVideo}`" ref="containerRow" no-gutters justify="space-between" align="center">
        <v-col class="container-screen" ref="containerScreen" align-self="center" align="center">
          <video
            class="screenVideo"
            :style="`width: ${screenVideoWidth > 0 ? screenVideoWidth + 'px' : 'auto'}`"
            ref="screenVideo"
            :srcObject.prop="screenStream"
            autoplay
            muted
          />
          <!-- <video class="screenVideo" ref="screenVideo" :srcObject.prop="screenStream" autoplay muted /> -->
        </v-col>
        <!-- <v-col> -->
        <video
          :class="isShowFace ? 'faceVideo' : 'faceVideo-off'"
          :style="faceVideoCssProps"
          ref="faceVideo"
          :srcObject.prop="mediaStream"
          autoplay
          muted
        />
        <!-- </v-col> -->
      </v-row>
    </v-container>
    <record-fail-dialog
      v-if="isShowRecordFailDialog"
      @close="isShowRecordFailDialog = false"
      :isShowRecordFailDialog.sync="isShowRecordFailDialog"
    ></record-fail-dialog>
  </v-responsive>
  <!-- <canvas ref="canvas"></canvas>
  </v-container> -->
</template>

<script>
import Toast from '@/views/meeting/component/Toast'
import { isMacOS } from '@/common/lib/strLib'
import RecordFailDialog from '@/views/modal/RecordFailDialog'
import { clearInterval, setInterval } from 'worker-timers'

const State = Object.freeze({
  Normal: 'normal',
  RecordSetting: 'recordSetting',
  Recording: 'recording',
  Preview: 'preview',
})
const separatedSpaceMargin = 24,
  commonFrameRate = 24

export default {
  name: 'ScreenAndMediaRecorder',
  props: {
    isMuted: Boolean,
    form: Object,
    isShowFace: Boolean,
    isMicGranted: Boolean,
    isCameraGranted: Boolean,
    floatingState: String,
    containerSize: Number,
  },
  components: {
    RecordFailDialog,
  },
  mounted() {
    // this.getReady()
    // 비디오 가로, 세로 사이즈를 가져와야해서..
    //TODO 인터벌 필요 없을 때 끄기
    this.videoSizeInterval = setInterval(() => {
      const { offsetHeight } = this.$refs.screenVideo
      this.screenVideoOffsetHeight = offsetHeight
    }, 100)

    // const callDrawInterval = setInterval(() => {
    //   if (this.readytostart) {
    //     this.drawCanvas()
    //     clearInterval(callDrawInterval)
    //   }
    // }, 500)
    window.addEventListener('resize', this.refreshRecordingLayout)
  },
  data() {
    return {
      LAYOUT_CHANGE_THRESHOLD: 3,
      DEFAULT_CONTAINER_RATIO: 0.45,
      MIN_CONTAINER_WIDTH: 320,
      MAX_CONTAINER_WIDTH: 1280,
      MIN_PADDING_RATIO: 0.07,
      SEPARATED_LAYOUT_FACE_VIDEO_RATIO: 16 / 9,
      responsiveContainerWidth: this.containerSize ?? 0,
      screenVideoHeight: 0,
      screenVideoWidth: 0,
      State,
      videoOptions: {
        video: true,
        audio: true,
      },
      recorderOptions: {
        audioBitsPerSecond: 128000,
        videoBitsPerSecond: 2500000,
        videoBitsPerSecondCameraOff: 2500000,
        videoBitsPerSecondCameraOn: 2500000,
        mimeType: 'video/webm;codecs=h264',
      },
      captureCanvas: null,
      interval: null,
      screenStream: null,
      mediaStream: null,
      captureStream: null,
      // mergeStream: null,
      recorder: null,
      blobs: [],
      blob: null,

      audioRecorder: null,
      audioChunks: [],
      audioBlobs: [],
      audioChunkSize: 0,

      thumbnail: null,
      isRecord: false,
      ctx: null,
      startTime: null,
      pauseTime: null,

      // stt audio start, pause time
      audioPauseTime: null,
      audioSilenceList: [],

      totalPauseTime: 0,
      containerVideo: '',
      videoSizeInterval: null,
      screenVideoOffsetHeight: null,
      containerPaddingLeft: null,
      containerPaddingTop: null,
      separatedSpaceMargin,
      commonFrameRate,
      captureOptions: {
        video: {
          // frameRate: commonFrameRate,
          // width: { ideal: 1280 },
          // height: { ideal: 720 },
          width: { ideal: 1920, max: 1920 },
          height: { ideal: 1080, max: 1080 },
          cursor: 'always',
          resizeMode: 'crop-and-scale',
          logicalSurface: false,
        },
        audio: true,
        // selfBrowserSurface: true,
        // preferCurrentTab: true,
        // suppressLocalAudioPlayback: true,
        // logicalSurface: false,
      },
      // tempCounter: 0,
      // readytostart: false,
      isJustRecorderStop: false,

      // 녹화 실패 감지를 위한 flag
      checkRecordFail: 0,
      isShowRecordFailDialog: false,
      checkRecordFailInterval: null,
      isRecordPause: false,
    }
  },
  methods: {
    audioRecorderForSTT() {
      try {
        // audio Stream 이 없다면 시작하지 않음
        if (
          !this.captureStream ||
          !this.captureStream.getAudioTracks() ||
          this.captureStream.getAudioTracks().length === 0
        ) {
          return
        }
        // 변수 초기화
        const limit = 1024 * 1024 * 20
        this.audioChunks = []
        this.audioChunkSize = 0

        const recorderOptions = {
          audioBitsPerSecond: 64000,
          mimeType: 'audio/webm',
        }
        const audioStream = new MediaStream()
        audioStream.addTrack(this.captureStream.getAudioTracks()[0])

        this.audioRecorder = new MediaRecorder(audioStream, recorderOptions)
        this.audioRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data)
            this.audioChunkSize += event.data.size

            // blob 의 용량이 20MB 가 넘어가고, 녹화중이면 리코더 종료
            if (this.audioChunkSize >= limit && this.audioRecorder.state === 'recording') {
              this.audioRecorder.stop()
              this.audioPauseTime = new Date().getTime()
            }
          }
        }
        this.audioRecorder.onstop = () => {
          // 녹화가 끝났을 때 처리
          const blob = new Blob(this.audioChunks, {
            type: 'audio/webm',
          })
          this.audioBlobs.push(blob)

          // blob 의 용량이 20MB 가 넘어가서 끊긴거라면 다시 시작
          if (this.audioChunkSize >= limit) {
            this.audioRecorderForSTT()
          }
        }

        this.audioRecorder.start(10000)
        this.audioRecorder.pause()
      } catch (error) {
        console.log('error : ', error)
      }
    },
    drawCanvas() {
      this.captureCanvas = document.createElement('canvas')
      // this.captureCanvas = this.$refs.canvas
      this.ctx = this.captureCanvas.getContext('2d', { alpha: false, willReadFrequently: false })
      // this.ctx = this.captureCanvas.getContext('2d')

      const angle = (315 / 180) * Math.PI,
        cos = Math.cos(angle)

      let containerVideo = this.$refs.responsiveContainer.$el,
        // containerScreen = this.$refs.containerScreen,
        screenVideo = this.$refs.screenVideo,
        faceVideo = this.$refs.faceVideo

      if (this.interval !== undefined && this.interval !== null) clearInterval(this.interval)
      if (this.ctx !== undefined && this.ctx !== null)
        this.ctx.clearRect(0, 0, this.captureCanvas.width, this.captureCanvas.height)

      this.interval = setInterval(() => {
        if (this.captureCanvas && this.ctx) {
          // this.ctx.fillStyle = '#ffffff'
          // this.ctx.fillRect(0, 0, this.captureCanvas.width, this.captureCanvas.height)
          // this.ctx.drawImage(this.captureCanvas, 0, 0)

          // const gCO = this.ctx.globalCompositeOperation
          // this.ctx.globalCompositeOperation = 'copy'
          // this.ctx.drawImage(this.captureCanvas, 0, 0)
          // this.ctx.globalCompositeOperation = gCO

          let widthRate = screenVideo.videoWidth / screenVideo.offsetWidth,
            heightRate = screenVideo.videoHeight / screenVideo.offsetHeight,
            screenLeft = 0,
            screenTop = 0

          if (this.faceVideoData.layoutType === 'corner') {
            this.captureCanvas.width = screenVideo.videoWidth
            this.captureCanvas.height = screenVideo.videoHeight
          } else {
            this.captureCanvas.width = containerVideo.offsetWidth * widthRate
            this.captureCanvas.height = containerVideo.offsetHeight * heightRate
            screenTop = ((containerVideo.offsetHeight - screenVideo.offsetHeight) * heightRate) / 2

            if (this.faceVideoData.layoutType === 'overlap') {
              screenLeft = (screenVideo.offsetLeft + this.containerPaddingLeft) * widthRate
            } else if (this.faceVideoData.layoutType === 'separated') {
              let leftMargin = screenVideo.offsetLeft
              if (this.isShowFace && this.isCameraGranted)
                leftMargin =
                  this.faceVideoData.separatedAlign === 'left'
                    ? this.faceVideoData.width + this.separatedSpaceMargin
                    : screenVideo.offsetLeft

              screenLeft = (leftMargin + this.containerPaddingLeft) * widthRate
            }

            // Draw Background
            if (this.faceVideoData.isUseGradient && this.faceVideoData.gradient) {
              let length = Math.sqrt(
                this.captureCanvas.width * this.captureCanvas.width +
                  this.captureCanvas.height * this.captureCanvas.height
              )

              // create and render gradient
              this.ctx.fillStyle = this.ctx.createLinearGradient(0, this.captureCanvas.height, cos * length, 0)
              this.ctx.fillStyle.addColorStop(0, this.faceVideoData.gradient.start)
              this.ctx.fillStyle.addColorStop(1, this.faceVideoData.gradient.end)
            } else {
              this.ctx.fillStyle = this.faceVideoData.bgColor
            }
          }

          this.ctx.fillRect(0, 0, this.captureCanvas.width, this.captureCanvas.height)

          // Draw Screen Video
          // 설정 저장 시작
          this.ctx.save()
          // Round Rect 추가
          // this.roundRect(this.ctx, screenLeft, screenTop, screenVideo.videoWidth, screenVideo.videoHeight, 30)
          this.roundRect(
            this.ctx,
            screenLeft,
            screenTop,
            screenVideo.videoWidth,
            screenVideo.videoHeight,
            this.faceVideoData.layoutType === 'corner' ? 0 : 30
          )
          // 영역 자르기
          this.ctx.clip()
          // video 그리기
          this.ctx.drawImage(screenVideo, screenLeft, screenTop, screenVideo.videoWidth, screenVideo.videoHeight)
          // 설정 저장 전 단계로 복원
          this.ctx.restore()

          // Draw Face Video
          if (this.isShowFace && this.isCameraGranted) {
            let faceOffsetLeft = faceVideo.offsetLeft,
              faceWidth = faceVideo.offsetWidth * widthRate,
              faceHeight = faceVideo.offsetHeight * heightRate,
              facePositionX = faceVideo.offsetLeft * widthRate,
              facePositionY = faceVideo.offsetTop * heightRate,
              cornerScreenTop = 0

            if (this.faceVideoData.layoutType === 'corner') {
              faceOffsetLeft = faceVideo.offsetLeft - screenVideo.offsetLeft
              facePositionX = faceOffsetLeft * widthRate
              cornerScreenTop = ((containerVideo.offsetHeight - screenVideo.offsetHeight) * heightRate) / 2
              facePositionY = faceVideo.offsetTop * heightRate - screenTop - cornerScreenTop
            }

            // 설정 저장 시작
            this.ctx.save()
            // 원형으로 선택 되었을 경우

            if (this.faceVideoData.layoutType !== 'separated' && this.faceVideoData.shape === 'round') {
              // 선 그리기 시작
              this.ctx.beginPath()
              // Circle 추가
              this.ctx.arc(
                faceOffsetLeft * widthRate + faceWidth / 2,
                faceVideo.offsetTop * heightRate + faceWidth / 2 - cornerScreenTop,
                faceWidth / 2,
                0,
                Math.PI * 2,
                false
              )
            } else {
              // Round Rect 추가
              this.roundRect(this.ctx, facePositionX, facePositionY, faceWidth, faceHeight, 30)
            }
            // 영역 자르기
            this.ctx.clip()
            // 좌우 반전
            this.ctx.scale(-1, 1)
            // 반전 영역만큼 이동
            this.ctx.translate(-faceOffsetLeft * widthRate * 2 - faceWidth, 0)
            // video 그리기
            this.ctx.drawImage(faceVideo, facePositionX, facePositionY, faceWidth, faceHeight)
            // 설정 저장 전 단계로 복원
            this.ctx.restore()
          }
        }
      }, 1000 / this.commonFrameRate)

      this.setRecordStream()
    },
    async setRecordStream() {
      // this.mergeStream = [...this.captureCanvas.captureStream(this.commonFrameRate).getTracks()]
      // if (this.mediaStream !== null) {
      //   if (this.mediaStream && this.isMicGranted) {
      //     this.mediaStream.getAudioTracks().forEach((track) => (track.enabled = !this.isMuted))
      //     // this.mediaStream.getAudioTracks()[0].enabled = !this.isMuted
      //   }
      //   this.mediaStream.getVideoTracks().forEach((track) => (track.enabled = this.isCameraGranted && this.isShowFace))
      //   this.mergeStream.push(...this.mediaStream.getAudioTracks())
      // }
      // this.captureStream = new MediaStream(this.mergeStream)
      // const audioContext = new (window.AudioContext || window.webkitAudioContext || window.mozAudioContext)()

      // const stream_dest = audioContext.createMediaStreamDestination()
      // const source = audioContext.createMediaStreamSource(this.mediaStream)
      // source.connect(stream_dest)

      // const stream = stream_dest.stream

      // this.captureStream = stream
      // this.captureStream = new MediaStream(this.captureStream)

      const captureStream = await this.captureCanvas.captureStream(this.commonFrameRate)
      const videoTrack = captureStream.getTracks()
      let audioTrack

      if (this.mediaStream) {
        // MediaStream 음소거 제어
        if (this.mediaStream.getAudioTracks() && this.mediaStream.getAudioTracks().length > 0 && this.isMicGranted) {
          audioTrack = this.mediaStream.getAudioTracks()
          audioTrack.forEach((track) => (track.enabled = !this.isMuted))
        }
        // MediaStream 얼굴 녹화여부 제어
        if (this.mediaStream.getVideoTracks() && this.mediaStream.getVideoTracks().length > 0)
          this.mediaStream
            .getVideoTracks()
            .forEach((track) => (track.enabled = this.isCameraGranted && this.isShowFace))
      }

      // if (this.screenStream && this.screenStream.getAudioTracks() && this.screenStream.getAudioTracks().length > 0) {
      //   audioTrack = [...audioTrack, ...this.screenStream.getAudioTracks()]
      //   // audioTrack = [...this.screenStream.getAudioTracks()]
      // }

      // System Audio 와 MediaStream Audio 혼합
      const audioContext = new AudioContext()
      const dest = audioContext.createMediaStreamDestination()

      let isAvailableAudio = false

      try {
        // audio Node 생성
        if (this.mediaStream && this.mediaStream.getAudioTracks() && this.mediaStream.getAudioTracks().length > 0) {
          let audioIn_01 = audioContext.createMediaStreamSource(this.mediaStream)
          audioIn_01.connect(dest)
          isAvailableAudio = true
        }

        if (this.screenStream && this.screenStream.getAudioTracks() && this.screenStream.getAudioTracks().length > 0) {
          let audioIn_02 = audioContext.createMediaStreamSource(this.screenStream)
          audioIn_02.connect(dest)
          isAvailableAudio = true
        }
      } catch (err) {
        console.log('mix audio failed ', err)
      }

      // console.log('total audio Track ', audioTrack)
      const newStream = new MediaStream()
      if (
        isAvailableAudio &&
        dest &&
        dest.stream &&
        dest.stream.getAudioTracks() &&
        dest.stream.getAudioTracks().length > 0
      ) {
        for (let track of dest.stream.getAudioTracks()) {
          // console.log('add audio track : ', track)
          newStream.addTrack(track)
        }
      }
      if (videoTrack !== undefined && videoTrack !== null && videoTrack.length > 0) newStream.addTrack(videoTrack[0])
      this.captureStream = newStream

      this.$emit('startAnalyser', { micStream: this.mediaStream, micAndMediaStream: this.captureStream })

      // Apply difference bitrate depending on recording options
      this.recorderOptions.videoBitsPerSecond = this.isShowFace
        ? this.recorderOptions.videoBitsPerSecondCameraOn
        : this.recorderOptions.videoBitsPerSecondCameraOff

      this.recorder = new MediaRecorder(this.captureStream, this.recorderOptions)
      this.recorder.onstart = () => {
        if (this.recorder && this.recorder.state && this.recorder.state !== 'inactive') {
          // if (this.startTime === null) {
          this.startTime = new Date().getTime()
          // Chrome 111 버그로 인해 onstart, onstop 이 잘못 호출되는 이슈가 생김.
          // 따라서 해당 버전에서 startTime 이 null 로 설정되어 duration 관련 오류가 생겨서 편법으로 추가해줌.. 20230316 jsyoon
          // }
          if (this.isJustRecorderStop) {
            if (this.recorder.state === 'recording') {
              this.recorder.stop()
              this.$emit('finishRecordTrick')
            }
          }
        }
      }

      this.recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          this.checkRecordFail = 0
          this.blobs.push(event.data)
        }
      }
      this.recorder.onstop = () => {
        // this.recorder.requestData()
        if (this.recorder !== null && !this.isJustRecorderStop) {
          this.blob = new Blob(this.blobs, {
            type: 'video/webm',
          })
          this.addTotalPauseTime()
          let startTime = this.startTime ?? localStorage.getItem('startTime')
          localStorage.removeItem('startTime')
          let duration = (new Date().getTime() - startTime) / 1000 - this.totalPauseTime

          this.$emit('saveBlob', {
            blob: this.blob,
            audioBlobs: this.audioBlobs,
            duration: duration,
            audioSilenceList: this.audioSilenceList,
          })
        }
        // 녹화 중 녹화 취소 눌렀을 경우
        else {
          this.blob = []
          this.blobs = []
          this.audioBlobs = []
          this.startTime = null
          this.pauseTime = null
          this.totalPauseTime = 0
          this.isJustRecorderStop = false
        }
      }
    },
    async getReady() {
      try {
        if (this.screenStream === null) {
          this.screenStream = await navigator.mediaDevices.getDisplayMedia(this.captureOptions)
          // Capture Stream 공유 중지 눌렀을 경우 제어
          this.screenStream.getVideoTracks()[0].onended = () => this.$emit('stopSharing', this.isRecord)
          // return true

          if (this.screenStream.onmute && this.screenStream.getVideoTracks().length > 0)
            this.screenStream.getVideoTracks()[0].onmute = () => console.log('muted')
        }
        this.getUserMedia()
      } catch (err) {
        if (err !== undefined && err !== null) {
          let message = err.toString()
          if (message.includes('by system') && isMacOS()) {
            this.$store.dispatch('setShowPreferenceDialog', 'screen')
            // notify(this, 'Error', this.$t('systemDenied'), 'error')
          } else if (message.includes('NotReadableError')) {
            // notify(this, 'Error', this.$t('notReadableError'), 'error')

            const content = {
              component: Toast,
              props: {
                msg: this.$t('notReadableError'),
                // submsg: '',
              },
            }
            this.$toast.error(content)
          }
        }
        this.$emit('disableRecorder', 'screen')
        // this.readytostart = false
        this.$emit('readyToStart', false)
        return false
      }
    },
    async startRecord() {
      try {
        if (
          this.captureStream &&
          this.captureStream.active &&
          this.captureStream.getVideoTracks().length > 0 &&
          this.captureStream.getVideoTracks()[0].muted === false
        ) {
          this.isRecord = true

          localStorage.setItem('startTime', new Date().getTime())
          this.startTime = null
          this.audioPauseTime = null
          this.recorder.start(2000)

          // STT 를 사용하기 위한 audio recorder 추가
          if (
            this.captureStream &&
            this.captureStream.getAudioTracks() &&
            this.captureStream.getAudioTracks().length > 0
          ) {
            this.audioSilenceList = []
            this.audioRecorderForSTT()
          }

          this.checkRecordFailInterval = setInterval(() => {
            if (!this.isRecordPause) {
              if (this.checkRecordFail < 8) this.checkRecordFail += 1
              else {
                this.isShowRecordFailDialog = true
                this.clearRecordFailInterval()
              }
            }
          }, 1000)
        } else {
          this.isShowRecordFailDialog = true
        }
      } catch (err) {
        console.error('Error: ' + err)
      }
    },
    /**
     * params
     * ctx: canvas context
     * radius: 모서리 둥글게
     * fill: 안에 채우기
     * stroke: 외부 border
     */
    roundRect(ctx, x, y, width, height, radius = 5, fill = false, stroke = false) {
      if (typeof radius === 'number') {
        radius = { tl: radius, tr: radius, br: radius, bl: radius }
      } else {
        radius = { ...{ tl: 0, tr: 0, br: 0, bl: 0 }, ...radius }
      }
      ctx.beginPath()
      ctx.moveTo(x + radius.tl, y)
      ctx.lineTo(x + width - radius.tr, y)
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr)
      ctx.lineTo(x + width, y + height - radius.br)
      ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height)
      ctx.lineTo(x + radius.bl, y + height)
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl)
      ctx.lineTo(x, y + radius.tl)
      ctx.quadraticCurveTo(x, y, x + radius.tl, y)
      ctx.closePath()
      if (fill) {
        ctx.fill()
      }
      if (stroke) {
        ctx.stroke()
      }
    },
    setContainerWidth() {
      // switch (width) {
      //   case width > 0 && width < this.MIN_CONTAINER_WIDTH:
      //     this.responsiveContainerWidth = this.MIN_CONTAINER_WIDTH
      //     break
      //   case width > this.MIN_CONTAINER_WIDTH && width < this.MAX_CONTAINER_WIDTH:
      //     this.responsiveContainerWidth = width
      //     break
      //   case width > this.MAX_CONTAINER_WIDTH:
      //     this.responsiveContainerWidth = this.MAX_CONTAINER_WIDTH
      //     break
      //   default:
      //     this.responsiveContainerWidth = this.containerSize
      //     break
      // }
      this.responsiveContainerWidth = this.containerSize
    },
    getContainerWidth() {
      // return this.responsiveContainerWidth - this.$refs.responsiveContainer.$el.offsetLeft * 2
      return this.$refs.responsiveContainer.$el.offsetWidth
    },
    getContainerHeight() {
      return (this.$refs.responsiveContainer.$el.offsetWidth / 16) * 9
    },
    initRecordingLayout() {
      this.containerPaddingLeft = 0
      this.containerPaddingTop = 0
      this.setContainerWidth(-1)
    },
    refreshRecordingLayout() {
      let screenVideo = this.$refs.screenVideo
      let container = this.$refs.responsiveContainer
      if (!container || !screenVideo || !this.faceVideoData) return

      this.setContainerWidth(this.responsiveContainerWidth)

      switch (this.faceVideoData.layoutType) {
        case 'corner':
          this.setCornerLayout(screenVideo)
          break
        case 'overlap':
          this.setOverlapLayout(screenVideo)
          break
        case 'separated':
          this.setSeperateLayout(screenVideo)
          break
      }
    },
    setCornerLayout(screenVideo) {
      let currentScreenWidth = screenVideo.offsetWidth
      let currentScreenHeight = screenVideo.offsetHeight

      // 컨테이너 내에 넣을 수 있는 현재 화면의 최대 크기를 구함
      let maxDimension = this.getMaxDimension(
        this.getContainerWidth(),
        this.getContainerHeight(),
        currentScreenWidth,
        currentScreenHeight
      )

      let targetScreenHeight = maxDimension.height
      let targetScreenWidth = maxDimension.width

      let newScreenWidth
      let newScreenHeight

      let change = Math.abs(currentScreenWidth - targetScreenWidth)

      // 작은 변화로 지속적인 변화 방지
      if (change > this.LAYOUT_CHANGE_THRESHOLD) {
        this.setContainerWidth(targetScreenWidth)
        this.screenVideoWidth = targetScreenWidth
        newScreenWidth = targetScreenWidth
        newScreenHeight = targetScreenHeight
      } else {
        newScreenWidth = currentScreenWidth
        newScreenHeight = currentScreenHeight
      }

      //계산된 값을 Cotainer 및 Screen에 적용
      let containerWidth = this.getContainerWidth()
      let containerHeight = this.getContainerHeight()

      //웹캠 버블 위치 조정
      if (this.faceVideoData.position.top !== 'unset') {
        this.faceVideoData.position.top = ((containerHeight - newScreenHeight) / 2 / containerHeight) * 100
      }
      if (this.faceVideoData.position.bottom !== 'unset') {
        this.faceVideoData.position.bottom = ((containerHeight - newScreenHeight) / 2 / containerHeight) * 100
      }
      if (this.faceVideoData.position.left !== 'unset') {
        this.faceVideoData.position.left = ((containerWidth - newScreenWidth) / 2 / containerWidth) * 100
      }
      if (this.faceVideoData.position.right !== 'unset') {
        this.faceVideoData.position.right = ((containerWidth - newScreenWidth) / 2 / containerWidth) * 100
      }
    },
    setSeperateLayout(screenVideo) {
      // TODO 동적 가져오기 실패 / 이것 떄문에 뭔가 살짝 어그러지는 듯

      let faceVideo = this.$refs.faceVideo

      // Container 크기 구하기
      let containerWidth = this.getContainerWidth()
      let containerHeight = this.getContainerHeight()
      let minPadding = containerHeight * this.MIN_PADDING_RATIO

      let screenVideoRatio = screenVideo.offsetHeight / screenVideo.offsetWidth
      let screenMaxHeight = containerHeight - 2 * minPadding

      // TODO 다른 브라우져 edge지만, 에서도 16 / 9로 캠 화면 들어오는지 확인 필요
      if (this.isShowFace && faceVideo) {
        let faceHeight = screenMaxHeight
        let faceWidth = faceHeight / this.SEPARATED_LAYOUT_FACE_VIDEO_RATIO
        let screenWidth = screenMaxHeight / screenVideoRatio

        let maxDimension = this.getMaxDimension(
          containerWidth - 2 * minPadding - this.separatedSpaceMargin,
          containerHeight - 2 * minPadding,
          faceWidth + screenWidth,
          screenMaxHeight
        )
        screenMaxHeight = maxDimension.height
      }

      // console.log(
      //   '***** Max Dimension',
      //   screenMaxHeight / screenVideoRatio,
      //   screenMaxHeight,
      //   'screen',
      //   this.screenVideoWidth,
      //   this.screenVideoHeight,
      //   'face',
      //   this.faceVideoData.width,
      //   this.faceVideoData.height
      // )

      let screenWidthChange = Math.abs(this.screenVideoWidth - screenMaxHeight / screenVideoRatio)
      let faceVideoHeightChange = this.isShowFace ? Math.abs(this.faceVideoData.height - screenMaxHeight) : 0
      if (screenWidthChange > this.LAYOUT_CHANGE_THRESHOLD || faceVideoHeightChange > this.LAYOUT_CHANGE_THRESHOLD) {
        this.screenVideoWidth = screenMaxHeight / screenVideoRatio
        this.screenVideoHeight = screenMaxHeight
        if (this.isShowFace && faceVideo) {
          this.faceVideoData.height = screenMaxHeight
          this.faceVideoData.width = screenMaxHeight / this.SEPARATED_LAYOUT_FACE_VIDEO_RATIO
        }
      }

      let newTotalWidth = this.faceVideoData.width + this.screenVideoWidth + this.separatedSpaceMargin
      let paddingDiff = (containerWidth - newTotalWidth) / 2
      this.containerPaddingLeft = paddingDiff > minPadding ? paddingDiff : minPadding
      this.containerPaddingTop = 0

      // console.log(
      //   '***** Container',
      //   containerWidth,
      //   containerHeight,
      //   'screen',
      //   this.screenVideoWidth,
      //   screenMaxHeight,
      //   'face',
      //   this.faceVideoData.width,
      //   this.faceVideoData.height,
      //   'minPadding',
      //   minPadding,
      //   'newTotalWidth',
      //   newTotalWidth,
      //   'containerPaddingLeft',
      //   this.containerPaddingLeft,
      //   'paddingDiff',
      //   paddingDiff
      // )
    },
    setOverlapLayout(screenVideo) {
      let containerWidth = this.getContainerWidth()
      let containerHeight = this.getContainerHeight()
      let currentScreenWidth = screenVideo.offsetWidth
      let currentScreenHeight = screenVideo.offsetHeight

      //TODO 스크린 비율로?
      let maxDimension = this.getMaxDimension(
        containerWidth - 2 * containerWidth * this.MIN_PADDING_RATIO,
        containerHeight - 2 * containerHeight * this.MIN_PADDING_RATIO,
        currentScreenWidth,
        currentScreenHeight
      )

      // let targetScreenHeight = maxDimension.height
      let targetScreenWidth = maxDimension.width

      // 작은 변화로 지속적인 변화 방지
      let change = Math.abs(currentScreenWidth - targetScreenWidth)
      if (change < this.LAYOUT_CHANGE_THRESHOLD) return

      //계산된 값을 Cotainer 및 Screen에 적용
      // this.setContainerWidth(targetScreenWidth)
      this.screenVideoWidth = targetScreenWidth

      this.containerPaddingLeft = containerWidth * this.MIN_PADDING_RATIO
      this.containerPaddingTop = containerHeight * this.MIN_PADDING_RATIO
    },
    //주어진 Container 안에, 해당 사각영역을 최대로 배치할 수 있는 크기를 찾아 리턴
    getMaxDimension(containerWidth, containerHeight, targetWidth, targetHeight) {
      let maxTrialCount = 3

      let maxWidth = 0
      let maxHeight = containerHeight
      let targetRatio = targetHeight / targetWidth

      while (maxTrialCount--) {
        maxWidth = maxHeight / targetRatio

        if (maxWidth <= containerWidth) {
          break
        } else {
          let widthOverflow = maxWidth - containerWidth
          let adjustValue = (widthOverflow / maxWidth) * maxHeight

          maxHeight = Math.floor(maxHeight - adjustValue)
        }
      }
      return {
        width: maxWidth,
        height: maxHeight,
      }
    },
    sttRecorderPauseAndResume(isPause) {
      if (this.audioRecorder) {
        if (isPause && this.audioRecorder.state === 'recording') {
          this.audioPauseTime = new Date().getTime()
          this.audioRecorder.pause()
        } else if (!isPause && this.audioRecorder.state === 'paused') {
          this.audioRecorder.resume()

          let recordStart = this.startTime ?? localStorage.getItem('startTime')
          let pauseStart = !this.audioPauseTime ? 0 : Math.abs(this.audioPauseTime - recordStart) / 1000
          let pauseEnd = Math.abs(new Date().getTime() - recordStart) / 1000
          let duration = pauseEnd - pauseStart
          this.audioPauseTime = null
          this.audioSilenceList.push({
            start: pauseStart,
            end: pauseEnd,
            duration: duration,
          })
        }
      }
    },

    // 녹화 일시정지, 다시 시작
    pauseResumeRecord(isClear) {
      if (isClear) {
        // if (this.interval !== null) {
        //   clearInterval(this.interval)
        //   this.interval = null
        // }
        // if (this.ctx !== null && this.captureCanvas !== null)
        //   this.ctx.clearRect(0, 0, this.captureCanvas.width, this.captureCanvas.height)
        // delete this.captureCanvas
        // this.captureCanvas = null
        if (this.recorder.state === 'recording' || this.recorder.state === 'paused') {
          this.isJustRecorderStop = true
          this.audioRecorder.stop()
          this.recorder.stop()
          this.clearRecordFailInterval()
        }
      } else {
        if (this.recorder.state === 'recording') {
          this.pauseTime = new Date().getTime()
          this.isRecordPause = true
          this.recorder.pause()
          this.audioRecorder.pause()
        } else if (this.recorder.state === 'paused') {
          this.addTotalPauseTime()
          this.checkRecordFail = 0
          this.isRecordPause = false
          this.recorder.resume()
          this.audioRecorder.resume()
        }
      }
    },
    addTotalPauseTime() {
      if (this.pauseTime && this.pauseTime !== null && this.pauseTime > 0)
        this.totalPauseTime += (new Date().getTime() - this.pauseTime) / 1000
      this.pauseTime = null
    },
    async startRecordTrick() {
      if (this.recorder !== undefined && this.recorder !== null) {
        if (this.recorder.state === 'recording') this.recorder.resume()
        else this.recorder.start(200)

        this.isJustRecorderStop = true
      } else this.isShowRecordFailDialog = true
    },
    // 녹화 완료
    completeRecord() {
      this.isRecord = false

      if (this.audioRecorder !== null && this.audioRecorder.state !== 'inactive') this.audioRecorder.stop()
      if (this.recorder !== null && this.recorder.state !== 'inactive') this.recorder.stop()

      let isScreenNull = this.screenStream === null || this.screenStream.getTracks() === null
      let isFaceNull = this.mediaStream === null || this.mediaStream.getTracks() === null
      let isCaptureNull = this.captureStream === null || this.captureStream.getTracks() === null

      if (!this.screenStream) {
        setTimeout(() => {
          if (this.screenStream && this.screenStream.getTracks()) {
            this.screenStream.getTracks().forEach((track) => track.stop())
            this.screenStream = null
          }
        }, 1000)
      } else if (!isScreenNull) {
        this.screenStream.getTracks().forEach((track) => track.stop())
        this.screenStream = null
      }

      if (!this.mediaStream) {
        setTimeout(() => {
          if (this.mediaStream && this.mediaStream.getTracks()) {
            this.mediaStream.getTracks().forEach((track) => track.stop())
            this.mediaStream = null
          }
        }, 1000)
      } else if (!isFaceNull) {
        this.mediaStream.getTracks().forEach((track) => track.stop())
        this.mediaStream = null
      }
      if (!isCaptureNull) {
        this.captureStream.getTracks().forEach((track) => track.stop())
        this.captureStream = null
      }

      // Stream 이 정상적으로 꺼지지 않았을때를 대비해서 방어코드를 넣어준다.
    },
    // RecordSetting 시 카메라, 음성 녹음 사용 여부 설정 시
    stopMedia() {
      let tracks
      if (this.mediaStream !== null) {
        // if (this.isMuted && !this.isShowFace) {
        tracks = this.mediaStream.getTracks()
        // } else if (!this.isShowFace) tracks = this.mediaStream.getVideoTracks()
        if (tracks && tracks !== null) tracks.forEach((track) => track.stop())
        this.mediaStream = null
      }
    },
    async getUserMedia() {
      this.stopMedia()
      // 녹화 준비할 때 Mic 세팅
      if (this.isMicGranted) {
        this.videoOptions.audio = {
          deviceId: this.form.audioId,
          echoCancellation: true,
          noiseSuppression: true,
          sampleRate: 44100,
        }
      } else {
        this.videoOptions.audio = false
      }
      let width, height

      if (this.faceVideoData.layoutType === 'separated') {
        width = 270
        height = width * this.SEPARATED_LAYOUT_FACE_VIDEO_RATIO
      } else {
        width = 480
        height = 480
      }

      // 녹화 준비할 때 Video 세팅
      if (this.isCameraGranted && this.isShowFace) {
        this.videoOptions.video = {
          deviceId: this.form.videoId,
          width: width,
          height: height,
          frameRate: 30,
        }
      } else {
        this.videoOptions.video = false
      }
      this.callMedia()
    },
    async callMedia() {
      // if (this.isShowFace || !this.isMuted) {
      try {
        this.mediaStream = await navigator.mediaDevices.getUserMedia(this.videoOptions)
        // this.$emit('startAnalyser', this.mediaStream)
      } catch (err) {
        console.log('failed getUserMedia : ', err, this.form)
        if (err !== undefined && err !== null) {
          let message = err.toString()
          if (message.includes('Requested device not found')) {
            const content = {
              component: Toast,
              props: {
                msg: 'Requested device not found',
                // submsg: '',
              },
            }
            this.$toast.error(content)
            // notify(this, 'Error', this.$t('systemDenied'), 'error')
          }
        }
      }
      if (this.mediaStream === undefined || this.mediaStream === null) {
        this.$emit('disableRecorder', 'face')
        this.$emit('disableRecorder', 'audio')
      }
      // }
      // this.readytostart = true
      this.drawCanvas()
      this.$emit('readyToStart', true)
    },
    vw(v) {
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      return (v * w) / 100
    },
    pixelToVw(pixel) {
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      return (pixel * 100) / w
    },
    clearRecordFailInterval() {
      if (this.checkRecordFailInterval !== null) {
        clearInterval(this.checkRecordFailInterval)
        this.checkRecordFailInterval = null
      }
    },
  },
  beforeDestroy() {
    if (this.interval !== null) {
      clearInterval(this.interval)
      this.interval = null
    }
    if (this.videoSizeInterval !== null) {
      clearInterval(this.videoSizeInterval)
      this.videoSizeInterval = null
    }
    this.$emit('stopAnalyser')
    this.clearRecordFailInterval()
    this.completeRecord()
    this.blobs = []
    this.blob = null
    this.audioBlobs = []
    this.recorder = null
    this.screenStream = null
    this.mediaStream = null
    this.captureStream = null
    // this.mergeStream = null
    if (this.ctx !== null && this.captureCanvas !== null)
      this.ctx.clearRect(0, 0, this.captureCanvas.width, this.captureCanvas.height)
    delete this.captureCanvas
    this.captureCanvas = null
    this.ctx = null
    window.removeEventListener('resize', this.refreshRecordingLayout)
  },
  computed: {
    bgColor() {
      let color
      if (this.faceVideoData.layoutType === 'corner') color = 'transparent'
      else {
        color =
          this.faceVideoData.isUseGradient && this.faceVideoData.gradient
            ? 'linear-gradient(45deg,' + this.faceVideoData.gradient.start + ',' + this.faceVideoData.gradient.end + ')'
            : this.faceVideoData.bgColor
      }
      return color
    },
    faceVideoData() {
      return this.$store.getters.faceVideoData
    },
    isLayoutChanged() {
      this.initRecordingLayout()
      return this.$store.getters.isLayoutChanged
    },
    faceVideoCssProps() {
      // let faceVideoData = !JSON.parse(JSON.stringify(this.faceVideoData))
      //   ? this.faceVideoData
      //   : JSON.parse(JSON.stringify(this.faceVideoData))
      let faceVideoShapeCSS
      let faceVideoWidthCSS
      let faceVideoHeightCSS
      let faceVideoPositionType

      this.refreshRecordingLayout()

      if (this.faceVideoData.layoutType === 'separated') {
        // faceVideoWidthCSS = this.$refs.screenVideo ? 'auto' : '10vw'
        // faceVideoHeightCSS = '100%'
        // faceVideoHeightCSS = this.screenVideoOffsetHeight + 'px'
        // // faceVideoWidthCSS = 'auto'
        // faceVideoWidthCSS = this.screenVideoOffsetHeight / 2 + 'px'

        // const MIN_CHANGE = 2

        // let targetFaceVideoHeight = this.screenVideoOffsetHeight
        // let targetFaceVideoWidth = this.screenVideoOffsetHeight / 2

        // let faceVideo = this.$refs.faceVideo
        // let currentWidth = faceVideo ? faceVideo.offsetWidth : 0

        // let widthChange = Math.abs(currentWidth - targetFaceVideoWidth)

        // faceVideoWidthCSS = targetFaceVideoHeight + 'px'
        // faceVideoWidthCSS = widthChange > MIN_CHANGE ? targetFaceVideoWidth + 'px' : currentWidth + 'px'

        // faceVideoHeightCSS = this.$refs.screenVideo ? this.$refs.screenVideo.offsetHeight + 'px' : '100%'

        faceVideoWidthCSS = this.faceVideoData.width + 'px'
        faceVideoHeightCSS = this.faceVideoData.height + 'px'
        faceVideoShapeCSS = '5px'
        faceVideoPositionType = 'static'
      } else {
        faceVideoWidthCSS =
          this.faceVideoData.size === 'small' ? '6vw' : this.faceVideoData.size === 'medium' ? '8vw' : '11vw'

        faceVideoHeightCSS = faceVideoWidthCSS
        faceVideoShapeCSS = this.faceVideoData.shape == 'square' ? '5px' : faceVideoWidthCSS
        faceVideoPositionType = 'absolute'
      }

      return {
        '--faceVideoPosition-top': this.faceVideoData.position.top + '%',
        '--faceVideoPosition-left': this.faceVideoData.position.left + '%',
        '--faceVideoPosition-right': this.faceVideoData.position.right + '%',
        '--faceVideoPosition-bottom': this.faceVideoData.position.bottom + '%',
        '--faceVideoMargin-top': this.faceVideoData.margin.top,
        '--faceVideoMargin-bottom': this.faceVideoData.margin.bottom,
        '--faceVideoMargin-left': this.faceVideoData.margin.left,
        '--faceVideoMargin-right': this.faceVideoData.margin.right,
        '--faceVideoShape': faceVideoShapeCSS,
        '--faceVideoWidth': faceVideoWidthCSS,
        '--faceVideoHeight': faceVideoHeightCSS,
        '--faceVideoPosition-type': faceVideoPositionType,
      }
    },
  },
  watch: {
    // audioSilenceList: {
    //   deep: true,
    //   immediate: true,
    //   handler(val) {
    //     console.log('audioSilenceList : ', val)
    //   },
    // },
    isMuted(val) {
      if (this.recorder && this.isMicGranted)
        if (this.mediaStream !== undefined && this.mediaStream !== null) {
          this.mediaStream.getAudioTracks().forEach((track) => (track.enabled = !val))
          if (!val) this.$emit('startAnalyser', { micStream: this.mediaStream, micAndMediaStream: this.captureStream })
        } else this.getUserMedia()
    },
    isShowFace(val) {
      if (this.floatingState === State.RecordSetting) {
        if (val) {
          this.getUserMedia()
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler() {
        this.getReady()
      },
    },
    faceVideoData: {
      immediate: true,
      deep: true,
      handler(val) {
        let containerVideo = ''
        if (val.layoutType === 'separated') {
          containerVideo = `d-flex flex-no-wrap ${val.separatedAlign === 'left' ? 'flex-row-reverse' : 'flex-row'}`
        }

        this.containerVideo = containerVideo
      },
    },
    isLayoutChanged() {
      this.getUserMedia()
    },
    mediaStream(val) {
      if (
        val &&
        val !== null &&
        this.faceVideoData &&
        this.faceVideoData !== null &&
        this.faceVideoData.layoutType === 'corner'
      ) {
        this.refreshRecordingLayout()
      }
    },
    screenVideoOffsetHeight() {
      this.refreshRecordingLayout()
    },
  },
}
</script>

<style scoped>
/* video {
  width: 100% !important;
  height: auto !important;
} */
.container-video {
  position: relative;
  /* border-radius: 20px; */
  /* padding-top: var(--containerVideoPadding-top);
  padding-bottom: var(--containerVideoPadding-bottom); */
}
.container-screen {
  position: relative;
}
.faceVideo {
  width: var(--faceVideoWidth);
  height: var(--faceVideoHeight);
  position: var(--faceVideoPosition-type);
  top: var(--faceVideoPosition-top);
  left: var(--faceVideoPosition-left);
  right: var(--faceVideoPosition-right);
  bottom: var(--faceVideoPosition-bottom);
  margin-top: var(--faceVideoMargin-top);
  margin-bottom: var(--faceVideoMargin-bottom);
  margin-left: var(--faceVideoMargin-left);
  margin-right: var(--faceVideoMargin-right);
  /* margin-bottom: calc(1.2vw);
  margin-left: calc(1.2vw); */
  /* margin: calc(1.2vw); */
  border-radius: var(--faceVideoShape);
  transform: scale(-1, 1);
}
.faceVideo-off {
  width: 0.1px;
  height: 0.1px;
  position: absolute;
  left: 0%;
  bottom: 0%;
}
.screenVideo {
  border-radius: 0.7vw;
}
/* #canvas {
  width: 80vw;
} */
/* .container-responsive {
  opacity: 0 !important;
  position: absolute;
} */
/* .v-responsive >>> .v-responsive__sizer {
  padding-bottom: 60% !important;
} */
</style>
